import { Button } from "@dropbox/dig-components/buttons";
import { Modal } from "@dropbox/dig-components/modal";
import { Text, Title } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import { UIIcon } from "@dropbox/dig-icons";
import { OpenLine } from "@dropbox/dig-icons/dist/mjs/assets";
import { SharingAirplaneMini } from "@dropbox/dig-illustrations";
import { PAP_Select_DashInviteModalBuyLicenses } from "@mirage/analytics/events/types/select_dash_invite_modal_buy_licenses";
import { DROPBOX_ADMIN_URL } from "@mirage/mosaics/SettingsPage/useAdminUI";
import i18n from "@mirage/translations";
import { useCallback } from "react";
import { useDashTeamInvitePapLogger } from "./hooks/useDashTeamInvitePapLogger";
import styles from "./OverQuotaShared.module.css";

interface OverQuotaMemberLimitProps {
  isAdmin: boolean;
}

export function OverQuotaMemberLimit({ isAdmin }: OverQuotaMemberLimitProps) {
  const { logDashTeamInvitePapEvent } = useDashTeamInvitePapLogger();
  const logClickBuyLicenses = useCallback(() => {
    logDashTeamInvitePapEvent(PAP_Select_DashInviteModalBuyLicenses);
  }, [logDashTeamInvitePapEvent]);

  return (
    <Modal.Body>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        paddingTop="24"
        paddingBottom="68"
        data-testid="over-quota-member-limit-body"
      >
        <div className={styles.iconContainer}>
          <SharingAirplaneMini altText={"team_invite_image_alt_text"} />
        </div>
        <Title weightVariant="emphasized">
          {i18n.t("team_invite_over_quota_member_limit")}
        </Title>
        <Text color="subtle" variant="label" size="small">
          {isAdmin
            ? i18n.t("team_invite_admin_over_quota_member_limit_message")
            : i18n.t("team_invite_user_over_quota_member_limit_message")}
        </Text>
        {isAdmin && (
          <Box marginTop="Macro Small">
            <Button
              onClick={logClickBuyLicenses}
              variant="opacity"
              href={DROPBOX_ADMIN_URL}
              withIconEnd={<UIIcon size="small" src={OpenLine} />}
            >
              {i18n.t("team_invite_buy_licenses")}
            </Button>
          </Box>
        )}
      </Box>
    </Modal.Body>
  );
}
